<script setup>
import {noticeCandidates,baselineNotices,noticeVersion} from '~/utils/achievements/notices.mjs';
import {reachGoal} from '~/utils/metrika';
const guide=useJournalGuide(),client=useUser(),moment=ref(null),enabled=useState('award-motion',()=>true);
let timer,busy=false,last=0,owner='',seen={},queue=[],latest=[];
const key=()=>`uogorod.awards.seen.v2.${owner}`;
function save(){try{localStorage.setItem(key(),JSON.stringify(seen));}catch{}}
function showNext(){if(!enabled.value||moment.value||!queue.length)return;const next=queue.shift();seen[next.id]=Math.max(Number(seen[next.id])||0,noticeVersion(next));save();moment.value=next;if(['JOURNAL_GARDEN','JOURNAL_PLANT','JOURNAL_NOTE','JOURNAL_TABLE','JOURNAL_PRINT','JOURNAL_WELCOME'].includes(next.id))reachGoal(`achivment:${next.id}`,{id:client.value?.client_id});}
function close(){moment.value=null;showNext();}
async function check(){
 const id=String(client.value?.client_id||'');if(!id||busy||document.hidden||Date.now()-last<5000)return;
 busy=true;last=Date.now();
 try{
  const awards=await $fetch('/api/profiles/'+id+'/achievements');latest=awards;
  if(owner!==id){owner=id;queue=[];moment.value=null;const raw=localStorage.getItem(key());if(!raw){seen=baselineNotices(awards);save();return;}try{seen=JSON.parse(raw)||{};}catch{seen=baselineNotices(awards);}}
  if(!enabled.value||awards.some(a=>a.preview)){seen=baselineNotices(awards,seen);save();return;}
  for(const a of noticeCandidates(awards,seen)){
   if(a.id==='JOURNAL_WELCOME'&&(guide.value.active||guide.value.award)){seen[a.id]=noticeVersion(a);save();continue;}
   if(!queue.some(q=>q.id===a.id)&&moment.value?.id!==a.id)queue.push(a);
  }
  showNext();
 }catch{}finally{busy=false;}
}
const unhook=useNuxtApp().hook('page:finish',check);
watch(enabled,value=>{if(!value){queue=[];moment.value=null;seen=baselineNotices(latest,seen);save();}});
watch(()=>client.value?.client_id,()=>{owner='';last=0;queue=[];moment.value=null;check();});
onMounted(()=>{try{enabled.value=localStorage.getItem('uogorod.awards.motion')!=='off';}catch{}check();timer=setInterval(check,15000);});
onBeforeUnmount(()=>{clearInterval(timer);unhook();});
</script>
<template><ProfileAwardMoment v-if="moment" :key="moment.id+':'+moment.notice_stage" :award="moment" @close="close"/></template>
